<template>
  <h2 class="form-title">房地产价值分析大数据报告</h2>
  <div class="intro-content">
    <div class="paragraph">
      房地产价值大数据分析报告提供房价价值分析、周边分析、价格走势分析、成交明细情况、地段特征、业务赋能等功能，是买家和买方、资产并购基金经理、中介和咨询公司、研究员分析师、风控人员、企业决策者、银行和非银金融机构相关工作人员的强大助手和决策工具。
    </div>
    <div class="paragraph">
      优先提供贝壳找房版本，如果贝壳找房数据不能覆盖询价对象则提供资产信息网版本。
    </div>
    <div class="paragraph">
      报告市场价值980元，最新促销价更是低至99元/份。
    </div>
    <div class="paragraph">
        批量客户可联系：微信：ksqj08, duanshihuaweixin
    </div>
    <div class="paragraph">
      扫码下载分析报告样例(专业、权威、大数据、快捷)：
    </div>
    <div class="qrcode-row">
      <img class="qrcode" :src="require('/src/assets/images/fileA.png')" />
      <img class="qrcode" :src="require('/src/assets/images/fileB.png')" />
    </div>
    <div class="paragraph">房地产分析报告样例在线预览：</div>
    <div class="button-row">
      <el-button class="row-button" color="#626aef" @click="switchA">预览房地产分析报告1</el-button>
      <el-button class="row-button" color="#626aef" @click="switchB">预览房地产分析报告2</el-button>
    </div>
    <pdf-canvas v-if="showA" :url="PdfA.url"></pdf-canvas>
    <pdf-canvas v-if="showB" :url="PdfB.url"></pdf-canvas>
  </div>
</template>

<script>
import { ElButton } from 'element-plus'
import PdfCanvas from '../PdfCanvas.vue'
export default {
  name: "IntroTable",
  data() {
    return {
      PdfA: {
        url: '/beikeReport.pdf'
      },
      PdfB: {
        url: '/qianjiReport.pdf'
      },
      showA: false,
      showB: false,
    };
  },
  methods: {
    switchA() {
      this.showA = true
      this.showB = false
    },
    switchB() {
      this.showA = false
      this.showB = true
    },
  },
  components: {PdfCanvas,ElButton},
};
</script>
<style lang="less">
.form-title {
  padding-left: 15px;
}
.intro-content {
  padding-left: 25px;
}
.paragraph {
  text-indent: 2rem;
}
.logo-row {
  height: 100px;
  width: 100%;
  text-align: center;
  margin: 10px auto 10px auto;
  @media (max-width: 768px) {
    height: 200px;
  }
  .comp-logo {
    height: 100%;
    @media (max-width: 768px) {
      height: 100px;
    }
  }
}
.button-row {
  width: 100%;
  padding: auto auto;
  text-align: center;
}
.qrcode-row {
  text-align: center;
  .cuxiao {
    max-width: 90%;
    max-height: 750px;
  }
  .qrcode {
    width: 45%;
    max-width: 250px;
  }
}
</style>
